var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponent5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 347,
    viewBox: "0 0 308 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.361 91.7174C245.361 91.7174 240.367 88.4254 230.628 83.686C230.607 83.6746 234.08 67.2801 234.095 65.7304C233.3 66.0285 232.603 67.2136 232.603 67.2136C232.603 67.2136 226.838 81.5318 226.734 81.7429C218.392 78.207 210.335 75.0981 200.79 71.5544C200.567 71.8604 216.496 81.2396 224.778 85.7084C224.433 86.4036 216.629 99.3234 215.791 100.981C215.586 101.955 215.977 102.36 215.977 102.36C215.977 102.36 228.381 88.0545 228.73 87.3753C238.923 91.8288 244.089 93.6985 244.089 93.6985C250.79 95.7737 245.367 91.7072 245.367 91.7072",
    fill: "#799DD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.019 63.6688C85.7096 41.978 -38.6135 80.857 -95.3196 195.956L-84.4723 197.833C-54.9344 118.631 69.529 28.5356 196.582 71.7416C193.691 69.1594 173.663 64.5729 170.019 63.6688Z",
    fill: "#799DD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent5);
export default __webpack_public_path__ + "static/media/Component 5.3c4c516be996491aa89c4b2d64a1215e.svg";
export { ForwardRef as ReactComponent };